import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/users/users.vue'

export default class extends Controller {
  static values = {
    users: []
  }

  connect() {
    const props = {
      users: this.usersValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
